module.exports = __webpack_public_path__ + "img/mk.8e28b928.svg";